// Code from unity3
// Path: unity3/skin/frontend/smartbox_rwd_v1/revamp/src/js/vanilla/helper/mediaQueries.js
// Add other queries when needed.
const remBase = 16;
const mdViewport = 768 / remBase;

export const mediumUp = () => {
  return window.matchMedia(`(min-width:${ mdViewport }rem)`);
};
